"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TopBarDesktop;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactstrap = require("reactstrap");

var _config = _interopRequireDefault(require("@dom/config"));

var _utils = require("@dom/utils");

var _Link = _interopRequireDefault(require("./Link"));

var _Toggler = _interopRequireDefault(require("../Toggler"));

var _UserDropdown = _interopRequireDefault(require("./UserDropdown"));

var _FlightsDropdown = _interopRequireDefault(require("./FlightsDropdown"));

var navBarLogo = "".concat(_config["default"].ASSETS_URL, "/navbar_logo.png");

function TopBarDesktop(props) {
  var userInfo = props.userInfo;
  var isUserLoggedIn = userInfo && Boolean(userInfo.userId);
  var goToGuideListings = _utils.makeUrl.goToGuideListings,
      goToTreks = _utils.makeUrl.goToTreks,
      goToLodge = _utils.makeUrl.goToLodge,
      goToTransportation = _utils.makeUrl.goToTransportation,
      goToBlog = _utils.makeUrl.goToBlog;
  return _react["default"].createElement(_Toggler["default"], null, function (_ref) {
    var on = _ref.on,
        toggle = _ref.toggle;
    return _react["default"].createElement(_reactstrap.Navbar, {
      color: "faded",
      light: true,
      expand: "md",
      className: "bg-white fix-padding"
    }, _react["default"].createElement("div", {
      className: "container"
    }, _react["default"].createElement("a", {
      href: "/",
      className: "navbar-brand"
    }, _react["default"].createElement("img", {
      src: navBarLogo,
      alt: "HoneyGuide Logo"
    })), _react["default"].createElement(_reactstrap.NavbarToggler, {
      onClick: toggle
    }), _react["default"].createElement(_reactstrap.Collapse, {
      isOpen: on,
      navbar: true
    }, _react["default"].createElement(_reactstrap.Nav, {
      className: "ml-auto menu-list",
      navbar: true
    }, _react["default"].createElement(_Link["default"], {
      useAnchor: true,
      linkTo: goToTreks,
      linkIcon: "tour.svg",
      title: "Tours"
    }), _react["default"].createElement(_FlightsDropdown["default"], null), _react["default"].createElement(_Link["default"], {
      useAnchor: true,
      linkTo: goToLodge,
      linkIcon: "lodge.svg",
      title: "Lodges"
    }), _react["default"].createElement(_Link["default"], {
      useAnchor: true,
      linkTo: goToGuideListings,
      linkIcon: "guide.svg",
      title: "Guides"
    }), _react["default"].createElement(_Link["default"], {
      useAnchor: true,
      linkTo: goToTransportation,
      linkIcon: "transport.svg",
      title: "Transport"
    }), _react["default"].createElement(_Link["default"], {
      useAnchor: true,
      linkTo: goToBlog,
      linkIcon: "blog.svg",
      title: "Blog"
    }), isUserLoggedIn && _react["default"].createElement(_UserDropdown["default"], (0, _extends2["default"])({}, props, {
      isUserLoggedIn: isUserLoggedIn
    }))))));
  });
}